var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"dashboard-greeting mb-4"},[_c('h2',{staticClass:"text-h5 font-weight-bold mb-1 secondary--text"},[_vm._v(" Hello "+_vm._s(_vm.userName)+", ")]),_c('p',{staticClass:"text-body-2 mb-0 grey--text text--darken-1"},[_vm._v(" "+_vm._s(_vm.date)+" ")])])
}
var staticRenderFns = []

export { render, staticRenderFns }